// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Unable to Accept a Payment</h1>
        </div>
        <div class="hoa-dialog__main">
            <p class="u-textCenter">
                We are unable to accept a payment for this property.
                Please contact your management company for more information. {{ data?.reasonCode }}
            </p>
            <p class="u-textCenter"></p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130" (click)="closeDialog(0)">OK</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;